<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" @click.stop="">
            <div
                class="modal bg-white overflow-x-auto flex flex-col shadow-xl rounded w-144"
                role="dialog"
                :aria-labelledby="modalTitleId"
                :aria-describedby="modalDescriptionId"
            >
                <header
                    :id="modalTitleId"
                    class="modal-header flex items-center justify-between py-3 px-4 border-b border-gray-400"
                >
                    <slot name="header">
                        <h3 class="font-bold text-xl text-teal-600">{{ modalTitle }}</h3>

                        <button
                            v-if="showCloseBtn"
                            type="button"
                            class="btn-close text-teal-600 p-2 focus:outline-none"
                            aria-label="Close modal"
                            @click="close"
                        >
                            <i class="fa fa-close"></i>
                        </button>
                    </slot>
                </header>
                <section :id="modalDescriptionId" class="modal-body px-4 py-3">
                    <slot name="body">
                        I'm the default body!
                    </slot>
                </section>
                <footer class="modal-footer py-3 px-4 border-t border-gray-400 shadow-md">
                    <slot name="footer">
                        <button
                            v-if="showCloseBtn"
                            type="button"
                            class="btn btn-primary float-right"
                            aria-label="Close modal"
                            @click="close"
                        >
                            Close
                        </button>
                    </slot>
                </footer>
            </div>
        </div>
    </transition>
</template>

<script>
import uniqueId from 'lodash/uniqueId';

export default {
    props: {
        modalTitle: {
            type: String,
            default: 'Modal Title'
        },
        closeConfirmMessage: {
            type: String,
            default: null
        },
        showCloseBtn: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            modalTitleId: uniqueId('modal-title-'),
            modalDescriptionId: uniqueId('modal-description-')
        };
    },

    methods: {
        close() {
            if (this.closeConfirmMessage === null) {
                this.$emit('close');
                return;
            }

            if (confirm(this.closeConfirmMessage)) {
                this.$emit('close');
            }
        }
    }
};
</script>

<style>
.modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal {
    box-shadow: 2px 2px 20px 1px;
}

.modal-body {
    max-height: 70vh;
    overflow-y: scroll;
}
/* .modal-header {
    border-bottom: 1px solid #eeeeee;
    color: #4aae9b;
    justify-content: space-between;
} */

.btn-green {
    color: white;
    background: #4aae9b;
    border: 1px solid #4aae9b;
    border-radius: 2px;
}

.modal-fade-enter,
.modal-fade-leave-active {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity 0.5s ease;
}
</style>
